import { createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["placeholder", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "fas fa-search me-2 new-typeahead-search"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "dropdown-divider"
}
const _hoisted_6 = { class: "me-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" (Add")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(") ")
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "dropdown-header text-default"
}
const _hoisted_12 = {
  key: 0,
  class: "dropdown-header text-default"
}
const _hoisted_13 = {
  key: 1,
  class: "dropdown-header text-default"
}
const _hoisted_14 = {
  key: 2,
  class: "dropdown-header text-default"
}
const _hoisted_15 = {
  key: 3,
  class: "dropdown-header text-default"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`new-typeahead dropdown ${_ctx.showMenu ? 'focused' : ''}`),
    ref: "dropdownRef"
  }, [
    _createCommentVNode(" INPUT "),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      class: _normalizeClass(`form-control form new-typeahead-input pe-4 ${_ctx.inputClasses}`),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchKey) = $event)),
      autocomplete: "off",
      onKeydown: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleInputKeydown($event))),
      onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleInputFocus())),
      ref: "searchInputRef",
      placeholder: _ctx.placeholder,
      disabled: _ctx.disabled,
      onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.emitBlur && _ctx.emitBlur(...args)))
    }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_1), [
      [_vModelText, _ctx.searchKey]
    ]),
    (!_ctx.hideIcon)
      ? (_openBlock(), _createElementBlock("i", _hoisted_2))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" DROPDOWN MENU "),
    (_ctx.searchKey?.length > 0 || (_ctx.data && _ctx.data.length > 0))
      ? (_openBlock(), _createElementBlock("ul", {
          key: 1,
          class: _normalizeClass(`dropdown-menu ${_ctx.showMenu ? 'show' : ''}`),
          ref: "dropdownMenuRef"
        }, [
          _createCommentVNode(" SEARCH RESULTS "),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (option) => {
            return _withDirectives((_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(`dropdown-item ${_ctx.highlightedOption && _ctx.highlightedOption === option ? 'active' : ''}`),
              onClick: ($event: any) => (_ctx.handleMenuSelection(option)),
              ref_for: true,
              ref: `optionRefs-$index`
            }, [
              _createElementVNode("span", {
                class: "me-2",
                innerHTML: option.name
              }, null, 8 /* PROPS */, _hoisted_4)
            ], 10 /* CLASS, PROPS */, _hoisted_3)), [
              [_vShow, _ctx.searchResults.length > 0]
            ])
          }), 256 /* UNKEYED_FRAGMENT */)),
          (_ctx.noMatchesFound && _ctx.isCustomAddEnabled && !_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("li", _hoisted_5))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" ADDING SEARCH KEY "),
          (_ctx.noMatchesFound && _ctx.isCustomAddEnabled && !_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("li", {
                key: 1,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addCustomOption())),
                class: _normalizeClass(`dropdown-item ${_ctx.isNewHighlightedOption ? 'active' : ''}`),
                ref: "customAddElementRef"
              }, [
                _createElementVNode("span", null, [
                  _createElementVNode("strong", _hoisted_6, _toDisplayString(_ctx.searchKey), 1 /* TEXT */),
                  (!_ctx.customAddMessage)
                    ? (_openBlock(), _createElementBlock("strong", {
                        key: 0,
                        class: _normalizeClass(`${_ctx.isNewHighlightedOption ? '' : 'text-app-secondary'}`)
                      }, [
                        _hoisted_7,
                        (_ctx.entity)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, " as " + _toDisplayString(_ctx.entity), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        _hoisted_9
                      ], 2 /* CLASS */))
                    : (_openBlock(), _createElementBlock("strong", _hoisted_10, " (" + _toDisplayString(_ctx.customAddMessage) + ") ", 1 /* TEXT */))
                ])
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" CHAR LIMIT MESSAGE "),
          (_ctx.searchKey && _ctx.searchKey.length < _ctx.searchCharLimit)
            ? (_openBlock(), _createElementBlock("li", _hoisted_11, _toDisplayString(_ctx.characterLimitMessage), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          (_ctx.searchKey?.length >= _ctx.searchCharLimit)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createCommentVNode(" NO RESULT "),
                (!_ctx.isCustomAddEnabled && !_ctx.isLoading && !_ctx.isError && _ctx.searchResults.length <= 0 && _ctx.isAuthorized)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_12, _toDisplayString(_ctx.noResultsMessage), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" ERROR "),
                (_ctx.isError && !_ctx.isLoading && _ctx.searchResults.length <= 0 && _ctx.isAuthorized)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_13, _toDisplayString(_ctx.errorMessage), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Insufficient User Permissions "),
                (_ctx.isError && !_ctx.isLoading && _ctx.searchResults.length <= 0 && !_ctx.isAuthorized)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_14, _toDisplayString(_ctx.notAuthorizedText), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" LOADING "),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_15, _toDisplayString(_ctx.loadingMessage), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}